import React from 'react';
import ReactDOM from 'react-dom/client'; // Use createRoot for React 18+
import './index.css';
import App from './App'; // Make sure the path to App.js is correct

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);

